import { groq } from 'next-sanity'
import cmsSettings from '../cmsSettings'
import { basicProductFields } from '../_shared'

export const fields = groq`
  _type,
  _id,
  ${cmsSettings()},
  products[]->{${basicProductFields}}
`

export const fragment = (name = 'homeProductList') => `${name}{ ${fields} }`

const exported = {
  fields,
  fragment,
}

export default exported
